/* eslint-disable react/no-typos */
import React, { useState } from 'react'
import { Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import product_default from "../../../assets/product_default.png";
import { MINUS, PLUS_ADD, } from "./CommonimagePath";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import VariationPage from '../../modal/components/VariationPage';
import RattingCommanPage from './RattingCommanPage';
import ButtonPage from '../button/ButtonPage';

export const Product = (props) =>{
    const { t } = useTranslation();
    const { item, is_productlist } = props;
      // Variation box
  const unitListrender = (variation) => {
    const variations = {
      label: props.language === "Tr" ? variation?.label_tr : variation?.label,
      label_tr: variation?.label_tr,
      value: variation?.value,
    };
    return variations?.label;
  }
    return(
    <React.Fragment>
        <Card
            className={"product "+props?.innerClass}
            onClick={(e) =>!is_productlist && props?.navigateToproductdetail(e, item?.pid)}
        >
            <div className='product_IMG'>
                {props?.detailTab === "products" && <Card.Img
                    alt=""
                    onError={(event) => {
                    event.target.src = product_default;
                    }}
                    src={
                    item?.images === null || item?.images === ""
                        ? product_default
                        : item?.img_url
                    }
                />}
                {props?.detailTab !== "products" && <Card.Img
                src={item.image_url ? item.image_url : product_default}
                alt={""}
                onError={(e) => {
                    e.target.src = product_default;
                }}
                />}
            </div>
            <Card.Body>
                <Card.Title className="productname">
                    {
                        props.detailTab === "store" ?(
                            item?.store_name
                        ):props.language === "Tr"
                            ? item?.title_in_tr
                            : item?.title
                    }
                    {(!is_productlist) && ( props?.addorremoveWish && 
                    <div
                        onClick={(e) => props?.addorremoveWish(e, item)}
                        style={{ float: "right" }}
                        alt=""
                        className={` heart_img ${item?.bookmark === "no"?"unsaved":"saved"}`}
                    />)}
                    {props?.is_wishlist&& ( props?.addorremoveWish && 
                    <div
                        onClick={(e) => props?.addorremoveWish(e, item)}
                        style={{ float: "right" }}
                        alt=""
                        className={` heart_img ${item?.bookmark === "no"?"unsaved":"saved"}`}
                    />)}
                </Card.Title>
                {props.detailTab === "store" && (
                    <p className="mt-1 mb-0 des">{item?.service_name}</p>
                )}
                <div className="product_info">
                    {props.detailTab !== "store" && 
                    <div className="card-text mt-1">
                        {item?.discount !== null &&
                        item?.discount !== 0 &&
                        item?.discount < item?.price ? (
                        <>
                            <del>
                            {item?.price}{" "}
                            {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </del>{" "}
                            <span
                            className="price"
                            style={{ marginLeft: "5px" }}
                            >
                            {item?.discount}{" "}
                            {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </span>
                        </>
                        ) : (
                        <span className="price">
                            {item?.price}{" "}
                            {process.env.REACT_APP_CURRENCY_SYMBOL}
                        </span>
                        )}
                        <br />
                        {item?.rating_ratio !== 0 && item?.rating_ratio !== null &&item?.rating_ratio !== undefined && (
                        <div className="review">
                            <RattingCommanPage
                                initialValue={item?.rating_ratio}
                                readonly={true}
                                size={14}
                            /> {item?.total_rating} {t('pages.Reviews')}
                        </div>
                        )}
                        <div
                            className={
                                item?.rating_ratio === 0
                                ? "mt-3 variation_btn"
                                : "select-var variation_btn"
                            }
                            >
                            {!is_productlist ? 
                                (item?.getVariation?.length > 0 &&( 
                                props?.showVariationModal ?<button onClick={(e)=>props?.showVariationModal(e, props?.index)} className='btn'>
                                   {unitListrender(item?.getVariation[0])}
                                </button>:
                                <button  className='btn'>
                                    {props?.language === "Tr"? item?.variations[0]?.label_tr:item?.variations[0]?.label}
                                </button>)
                                ) :  
                                ( item?.variations?.length > 0 && (
                                    <button disabled className='btn'>
                                    { item?.variations[0]?.quantity}  {props?.language === "Tr"? item?.variations[0]?.unit_in_tr:item?.variations[0]?.unit}
                                    </button>
                                )
                            )}
                        </div>
                    </div>}
                    <React.Fragment>
                        {!is_productlist &&(
                            <React.Fragment>
                                {props?.type === "vendor" ? (
                                    props?.store_id === props?.storeDetail?.store_id ? (
                                        item?.out_of_stock === true && (
                                            <h5 className='btn_outofstock' style={{ fontSize: "15px", color: "#FF0000" }} >
                                                {t("pages.Out of Stock")}
                                            </h5>
                                        )
                                    ) : item?.out_of_stock === true ? (
                                    <h5 className='btn_outofstock' style={{ fontSize: "15px", color: "#FF0000" }} >
                                        {t("pages.Out of Stock")}
                                    </h5>
                                    ) : item?.cart_detail ? (
                                    <div className="qty-action">
                                        <button 
                                            className="button-minus"
                                            onClick={(e) => props?.quantityMinus(e,item?.pid,item?.cart_detail)}
                                        >
                                            <img src={MINUS} height="18" width="18" alt="minus" />
                                        </button>
                                        <span className="qty">
                                            {item?.cart_detail?.quantity}
                                        </span>
                                        <ButtonPage
                                            Text={<img src={PLUS_ADD} height="18" width="18" alt="plus" />}
                                            onClick={(e) => props?.quantityPlus(e,item?.pid,item?.cart_detail)}
                                            className="button-minus"
                                            type={"button"}
                                        />
                                    </div>
                                    ) : (
                                    <ButtonPage
                                        Text={
                                        <React.Fragment>
                                            {t("pages.Add to Card")}
                                        </React.Fragment>
                                        }
                                        onClick={(e) => props?.addtoCart(e, item?.pid)}
                                        className="button-cart"
                                        type={"button"}
                                    />
                                    )
                                ) : item?.out_of_stock === true ? (
                                    <h5 className='btn_outofstock' style={{ fontSize: "15px", color: "#FF0000" }} >
                                        {t("pages.Out of Stock")}
                                    </h5>
                                ) : item?.cart_detail ? (
                                    <div className="qty-action">
                                        <button 
                                            className="button-minus"
                                            onClick={(e) => props?.quantityMinus(e,item?.pid,item?.cart_detail)}
                                        >
                                            <img src={MINUS} height="18" width="18" alt="minus" />
                                        </button>
                                        <span className="qty">
                                            {item?.cart_detail?.quantity}
                                        </span>
                                        <ButtonPage
                                            Text={<img src={PLUS_ADD} height="18" width="18" alt="plus_add" />}
                                            onClick={(e) => props?.quantityPlus(e,item?.pid,item?.cart_detail)}
                                            className="button-minus"
                                            type={"button"}
                                        />
                                    </div>
                                ) : (
                                    <ButtonPage
                                        Text={
                                            <React.Fragment>
                                                {/* <i className='mask_icon plus_icon' /> {t("pages.Add")} */}
                                                {t("pages.Add")} 
                                            </React.Fragment>
                                        }
                                        onClick={(e) => props?.addtoCart(e, item?.pid)}
                                        type={"button"}
                                        className=" button-cart"
                                    />
                                )}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                </div>
                {(is_productlist && !props?.is_wishlist) &&  (<React.Fragment>
                    <div className="action">
                        <div className="action-button">
                            <button className="btn edit_icon_button"  onClick={() => props?.productEdit( props?.item.pid)}>
                                <i className="mask_icon  pencil_outline grey p-0" />
                            </button>
                            <button className="btn delete_icon_button" onClick={() => props?.productDelete(props?.item)}>
                                <i className="mask_icon  delete_svg grey p-0" />
                            </button>
                        </div>
                        {props?.item?.variations[0]?.out_of_stock === true && (
                            <h5 className='btn_outofstock' style={{ fontSize: "15px", color: "#FF0000" }} >
                               {t("pages.Out of Stock")}
                            </h5>
                        )}
                    </div>
                </React.Fragment>)}
            </Card.Body>
        </Card>
    </React.Fragment>
    )
}
Product.propTypes={
    productDelete: PropTypes.any,
    productEdit: PropTypes.any,
    addtoCart: PropTypes.any,
    quantityPlus: PropTypes.any,
    quantityMinus: PropTypes.any,
    storeDetail: PropTypes.any,
    store_id: PropTypes.any,
    type: PropTypes.any,
    addorremoveWish: PropTypes.any,
    innerClass: PropTypes.any,
    navigateToproductdetail: PropTypes.any,
    showVariationModal:PropTypes.any,
    language:PropTypes?.any,
}
function ProductCommonPage(props) {
    // const { t } = useTranslation();
    // const { props?.navigateToproductdetail, item, props?.addorremoveWish, unitListrender, index, props?.store_id, props?.quantityMinus, props?.quantityPlus, props?.addtoCart } = props
    const { setProductlist, cartInformation, setCartinformation } = props
  const [showvaration, setShowvariation] = useState(false);
  const [productindex, setProductindex] = useState(0);

  const showVariationModal = (e, index) => {
    e?.stopPropagation();
    setProductindex(index);
    setShowvariation(true);
  };
  const callSetNoCard = (value) =>{
      if(props?.setNocart){
        props?.setNocart(value)
      }
  }
  return (
    <React.Fragment>
        <Row className={props.className}>
        { props?.data && props?.data.filter((label) => {
                if (props?.search === "") {
                    return label;
                }
                if (
                    label?.title
                    ?.toLowerCase()
                    .includes(props?.search?.toLowerCase())
                ) {
                    return label;
                }
                return null;
            })
            .map((item, index) => (
                <div className={props?.listClass} key={index?.toString()}>
                    <Product {...props}  showVariationModal={showVariationModal} item={item} index={index} listType={"product"} detailTab={"products"} />
                </div>
            ))}
        </Row>
        <VariationPage
            showvaration={showvaration}
            setShowvariation={setShowvariation}
            productindex={productindex}
            cartInformation={cartInformation}
            setCartinformation={setCartinformation}
            productlist={ props?.data}
            setProductlist={setProductlist}
            setNocart={callSetNoCard}
            store_id={props?.store_id}
        />
    </React.Fragment>
  )
}
const mapStateToProps = (state) => ({
    access_token: state?.login?.access_token,
    type: state?.login?.type,
    storeDetail: state?.dashboard?.storeDetail,
    cartdata: state?.home?.cartdata,
    amount: state?.home?.amount,
    language: state?.languageState?.language,
    categories: state?.home.categories,
    jid: state?.login?.jid,
    jpass: state?.login?.jpass,
  });
  
export default connect(mapStateToProps)(ProductCommonPage);